<template> 
<!-- 分页 -->
<div class="page-wrap">
  <el-pagination
    :hide-on-single-page="total <= pageSize"
    layout="prev, pager, next"
    :total="total"
    :page-size="pageSize"
    :current-page="currentPage"
    @current-change="handleCurrentChange">
  </el-pagination>
</div>
</template>

<script>
export default {
  props: {
    total: {
      default() {
          return 0
      },
      type: Number 
    },
    pageSize: {
      default() {
          return 2
      },
      type: Number 
    },
    currentPage: {
      default() {
          return 1
      },
      type: Number 
    }
  },
  methods: {
    handleCurrentChange(val) {
      this.$emit('pageChange',val)
    }
  }
}
</script>

<style lang="scss" scoped>
.page-wrap {
  width: var(--base-width);
  padding-bottom: 40px;
  margin: auto;
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/view/components/page.vue